import { forwardRef, Module } from '@nestjs/common';
import { Company } from '../entity/company.entity';
import { ApplicationExceptionHandler } from '@schemax-whatsapp/backend-utils';
import { TypeOrmModule } from '@nestjs/typeorm';
import { CompanyController } from './company.controller';
import { CompanyService } from './company.service';
import { ModuleModule } from '../module/module.module';
import { BiMessageModule } from '../bi-message/bi-message.module';

@Module({
    imports: [
        TypeOrmModule.forFeature([
            Company
        ]),
        forwardRef(()=> ModuleModule),
        forwardRef(()=> BiMessageModule)
    ],
    controllers: [CompanyController],
    providers: [CompanyService, ApplicationExceptionHandler],
    exports: [CompanyService]
})
export class CompanyModule {}

